import { ChangeDetectionStrategy, Component, computed, inject, Injector, input, linkedSignal, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CommonForm, CommonOptionsFieldConfig, CommonSelectField, CommonSelectFieldWidget, UrlService } from "@eforall/common";
import { BlockoutSlots, SelectedSlots, StandardFourTimeZoneId } from '@interfaces';
import { ScheduleTablePart } from '../schedule-table/schedule-table.part';

@Component({
	selector: 'schedule-viewer-part',
	standalone: true,
	imports: [ScheduleTablePart, CommonSelectFieldWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './schedule-viewer.part.html',
})

export class ScheduleViewerPart {

	public selectedSlots = input.required<SelectedSlots>();
	public numMeetings = input.required<number>();
	public blockoutSlots = input<BlockoutSlots[]>([]);
	public timeZoneId = input<StandardFourTimeZoneId | undefined>();
	public showApplicantTimeZone = input<boolean>(true);

	public selectedTimeZoneId = linkedSignal(() => this.timeZoneId() ?? 1);

	public readonly form = new CommonForm(inject(Injector));
	public readonly commonLabels = inject(UrlService).commonLabels;

	constructor() {
		toObservable(this.timeZoneIdField().pendingValue).subscribe((pendingValue: StandardFourTimeZoneId | null) => {
			if (pendingValue) {
				this.selectedTimeZoneId.set(pendingValue);
			}
		});
	}

	public applicantTimeZone = computed(() => {
		const timeZoneId = this.timeZoneId();
		const timeZoneLabels = this.commonLabels.TimeZoneMap.long;
		return timeZoneId ? timeZoneLabels[timeZoneId]() : 'Not Provided';
	});

	private readonly timeZoneOptions = computed(() => {
		const timeZoneLabels = this.commonLabels.TimeZoneMap.long;
		return Object.entries(timeZoneLabels).map(([key, label]) => ({
			value: Number(key) as StandardFourTimeZoneId,
			text: label(),
		}));

	});

	readonly timeZoneIdField = computed<CommonSelectField<StandardFourTimeZoneId>>(() => ({
		config: signal<CommonOptionsFieldConfig<StandardFourTimeZoneId>>({
			label: 'Time Zone ',
			options: this.timeZoneOptions(),
			isRequired: true, isSpanish: false
		}),
		actualValue: computed(() => this.selectedTimeZoneId()),
		pendingValue: signal<StandardFourTimeZoneId | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'timeZoneId',
		form: this.form,
	}));

}